export default "__VITE_ASSET__eb86e175__"